import { LoanPaymentMethodDetailEntity } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/_shared/entities/PaymentMethodDetail/LoanPaymentMethodDetailEntity';
import { useLoanPaymentIntent } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/_shared/hooks/useLoanPaymentIntent';
import { CustomRequiredFile } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/_shared/types';
import { UploadFileCard } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/NextActions/components/UploadDocuments/components/UploadRequiredFileCard';
import { DocumentGroupKey } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/NextActions/components/UploadDocuments/maps/requiredFilesByDocumentTypeGroup.map';
import { FlexColumn } from '@/components/shared/components/FlexColumn';
import { Font } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';

interface RequiredFilesDocumentGroupProps {
  groupKey: DocumentGroupKey;
  titleSuffix?: string;
  files: CustomRequiredFile[];
  paymentMethodDetailEntity: LoanPaymentMethodDetailEntity;
}

export const RequiredFilesDocumentGroup = ({
  groupKey,
  titleSuffix,
  files,
  paymentMethodDetailEntity,
}: RequiredFilesDocumentGroupProps) => {
  const { updatePaymentMethodEntity } = useLoanPaymentIntent();

  return (
    <FlexColumn gridGap={16} justifyContent={'center'} width={'100%'}>
      <Font variant="subtitle2" color="title">
        <Text strong tId={groupKey} />
        {titleSuffix}
      </Font>
      {files.map((requiredFile) => (
        <UploadFileCard
          key={`upload-file-card-${requiredFile.id}`}
          requiredFile={requiredFile}
          paymentMethodId={paymentMethodDetailEntity.loan!.id}
          paymentMethodType={paymentMethodDetailEntity.type}
          borrowerId={paymentMethodDetailEntity.loan!.borrowerId!}
          onUploadSuccess={async () => {
            const refreshedEntity = await paymentMethodDetailEntity.waitUntilRequiredFileUploaded(requiredFile);
            updatePaymentMethodEntity(refreshedEntity);
          }}
        />
      ))}
    </FlexColumn>
  );
};
